import { TextField } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ParentScreenCtx } from "../../pages/workbench_build/WorkbenchBuild";
import { useDispatch, useSelector } from "react-redux";
import { treeActions } from "../../redux/slices/treeSlice";
import { eachDeep } from "deepdash-es/standalone";
import { cloneDeep } from "lodash";

function GraphQLQueryEditor() {
  const { t } = useTranslation();
  const [graphQLText, setGraphQLText] = useState("");
  const parentScreen = useContext(ParentScreenCtx)
  const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
  const selectedNode = rightTree.tree[rightTree.currentTab].selectedNode;
  const translatedData = rightTree.tree[rightTree.currentTab].translatedData;
  const dispatch=useDispatch();
  
  const saveGraphQLQuery = () => {
    const value = graphQLText;
    const updatedData = eachDeep(cloneDeep(translatedData), (obj) => {
          if (obj?.key !== selectedNode.key) return;
          obj.FIELD.VALUE = value;
          dispatch(
            treeActions.setRightTreeSelectedNode({
              screen: parentScreen,
              type: rightTree.currentTab,
              data: obj,
            })
          );
        });
        dispatch(
          treeActions.setNewRightTreeTranslatedData({
            screen: parentScreen,
            type: rightTree.currentTab,
            data: updatedData,
          })
        );
  };

 useEffect(() => {
    setGraphQLText(selectedNode?.FIELD?.VALUE || "");
 },[selectedNode?.key, selectedNode?.FIELD?.VALUE]);

  return (
    <>
      <div
        style={{
          width: "100%",
          height: "100%",
          padding: 0,
          alignSelf: "stretch",
          display: "flex",
          flexDirection: "column",
        }}>
        <TextField
          multiline
          fullWidth
          value={graphQLText}
          onChange={(e) => setGraphQLText(e.target.value)}
          onBlur={saveGraphQLQuery}
          aria-label="graphql-editor"
          variant="standard"
          InputProps={{ disableUnderline: true }}
          inputProps={{ tabIndex: 0 }}
          onMouseDown={(e) => {
            // Prevent parent tree handlers from stealing focus/clicks
            e.stopPropagation();
          }}
          onClick={(e) => {
            e.stopPropagation();
          }}
          onKeyDown={(e) => {
            // Prevent arrow key navigation in the parent tree while typing
            e.stopPropagation();
          }}
          sx={{
            pointerEvents: "auto",
            width: "100%",
            height: "100%",
            "& .MuiInputBase-root": { height: "100%" },
            "& .MuiInputBase-input": {
              height: "100% !important",
              padding: "12px",
              boxSizing: "border-box",
              whiteSpace: "pre-wrap",
              overflow: "auto !important",
            },
          }}
        />
      </div>
    </>
  );
}

export default GraphQLQueryEditor;
